export default class TopNavigation {
    private topLinkButtons: NodeListOf<HTMLAnchorElement>;
    private header: HTMLElement;
    constructor() {
        this.initElement();
        this.attachEventListener();
        this.skipMenu();
        this.initQuickExit();
    }
    private initElement() {
        this.header = document.querySelector('.header');
        this.topLinkButtons = document.querySelectorAll('.link-item');
    }
    private attachEventListener() {
        this.topLinkButtons.forEach(btn => {
            const currentPageUrl = window.location.href;
            if (btn.href === currentPageUrl) {
                btn.classList.add('active');
            }
        });
        window.addEventListener('resize', () => {
            this.updateSkipToSearchTarget()
        })
    }
    private skipMenu() {
        const skipLinks = this.header.querySelectorAll<HTMLAnchorElement>(".skip");
        this.updateSkipToSearchTarget();
        skipLinks.forEach(function (skipLink) {
            skipLink.addEventListener("click", function () {
                const targetId = this.getAttribute("href").substring(1);
                const targetElement = document.getElementById(targetId);

                if (targetElement) {
                    targetElement.focus();
                }
            });
        });
    }
    private updateSkipToSearchTarget() {
        const skipLink = document.getElementById("skip-to-search") as HTMLAnchorElement;
        if (window.innerWidth < 992) {
            skipLink.href = "#mobile-search-btn";
        } else {
            skipLink.href = "#header-search-input";
        }
    }
    private initQuickExit() {
        const quickExitButton = document.querySelector('.quick-exit-button') as HTMLAnchorElement;
        if (!quickExitButton)
            return;
        const redirectUrl = quickExitButton.href;
        document.addEventListener('keydown', (e: KeyboardEvent) => {    
            if (e.key == 'Escape') {
                e.preventDefault();
                window.location.replace(redirectUrl);
            }
        })
        quickExitButton.addEventListener('click', (e: Event) => {
            e.preventDefault();
            window.location.replace(redirectUrl);   
        })
    }
}
